import { ConsumerStore } from "./consumer";
export * from "./types";
export class ContentStore {
    consumerStores = {};
    getOrCreateConsumerStore(consumerId) {
        const store = this.consumerStores[consumerId];
        if (store !== undefined) {
            return store;
        }
        const newStore = new ConsumerStore();
        this.consumerStores[consumerId] = newStore;
        return newStore;
    }
    getContent(consumerId) {
        return this.getOrCreateConsumerStore(consumerId).getContent();
    }
    setContent(consumerId, content) {
        this.getOrCreateConsumerStore(consumerId).setContent(content);
    }
    onContentChange(consumerId, listener) {
        this.getOrCreateConsumerStore(consumerId).addListener(listener);
    }
    removeOnContentChange(consumerId, listener) {
        this.getOrCreateConsumerStore(consumerId).removeListener(listener);
    }
}
//# sourceMappingURL=index.js.map